package com.rosario.juridico

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

enum class UpdateStatus {
    IDLE,
    AVAILABLE,
    DOWNLOADING,
    DOWNLOADED,
    INSTALLING
}

object AppUpdateState {
    private val _status = MutableStateFlow(UpdateStatus.IDLE)
    val status: StateFlow<UpdateStatus> = _status

    private val _downloadProgress = MutableStateFlow(0)
    val downloadProgress: StateFlow<Int> = _downloadProgress

    fun updateStatus(newStatus: UpdateStatus) {
        _status.value = newStatus
    }

    fun updateProgress(progress: Int) {
        _downloadProgress.value = progress
    }

    // Callbacks to be implemented in platform-specific code (MainActivity)
    var onUpdateRequested: (() -> Unit)? = null
    var onInstallRequested: (() -> Unit)? = null
}
